// Generated by CoffeeScript 2.7.0
var CascadedSelectMixin;

export default CascadedSelectMixin = {
  computed: {
    fullName: function() {
      if (this.value && this.value.getPath) {
        return _.pluck(this.value.path, 'name').join('-');
      } else if (this.value) {
        return this.value.name;
      } else {
        return '';
      }
    },
    resource: function() {
      return `/cascaded_selects/${this.field.cascaded_select_id}/choices`;
    },
    defaultValue: function() {
      return this.value && this.value.id;
    },
    valueForCalculation: function() {
      return {
        type: 'Text',
        value: this.fullName
      };
    }
  },
  methods: {
    _validate: function() {
      if (!this.value) {
        return;
      }
      if ((!_.isEmpty(this.value.children)) && this.field.settings.only_leaf) {
        return this._addError("请选择到最后一个层级");
      }
    },
    _parseValueToEntries: function() {
      var _result, result;
      _result = [];
      if (this.entries.length) {
        result = _.clone(this.entries[0]);
        if (this.value) {
          result.value = this.fullName;
          result._destroy = false;
          result.choice_id = this.value.id;
          result.choice = _.pick(this.value, 'id', 'name', 'ancestry');
        } else {
          if (result.id) {
            result._destroy = true;
          } else {
            result = null;
          }
        }
      } else {
        if (this.value) {
          result = {
            value: this.fullName,
            choice_id: this.value.id,
            field_id: this.field.id,
            choice: _.pick(this.value, 'id', 'name', 'ancestry')
          };
        }
      }
      if (result) {
        _result.push(result);
      }
      return _result;
    },
    _initDefaultEntries: function(entries) {
      return entries[0] || {};
    },
    _parseEntriesToValue: function(entry) {
      var choice;
      if (entry.choice) {
        choice = entry.choice;
        choice.name = entry.value;
        return this.value = new Skylark.Libs.HierarchicalTreeNode(choice);
      } else {
        return this.value = null;
      }
    }
  }
};
